var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-card-piccola"},[_c('div',{staticClass:"titolo col-24 no-padding"},[_vm._v("\n    "+_vm._s(_vm.properties.title.toUpperCase())+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"valore col-24 no-padding"},[_vm._v("\n    "+_vm._s(_vm.properties.value)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ec12124","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceComponents/CardPiccola.vue
// module id = null
// module chunks = 